var map = {
	"./v2-home-certificates.svg": 4732,
	"./v2-home-channels.svg": 4733,
	"./v2-home-clp.svg": 4734,
	"./v2-home-courses.svg": 4735,
	"./v2-home-exams.svg": 4736,
	"./v2-home-gamification.svg": 4737,
	"./v2-home-leaderboard.svg": 4738,
	"./v2-home-projects.svg": 4739,
	"./v2-home-resume.svg": 4740
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4731;